// extracted by css-extract-rspack-plugin
export default {"separatorBlock":"lKzhM61B","separatorVariantLine":"a0yjJfPf","separatorVariantSubheader":"y0j50S3H","separatorHierarchySecondary":"McbxPZKT"};